import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=1f51ba0c&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=1f51ba0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f51ba0c",
  null
  
)

export default component.exports